import { render, staticRenderFns } from "./UdRatio.vue?vue&type=template&id=6e36bb1c&"
import script from "./UdRatio.vue?vue&type=script&lang=js&"
export * from "./UdRatio.vue?vue&type=script&lang=js&"
import style0 from "./UdRatio.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports